import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function RealEstatePage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['real-estate']} />;
}
